import EventHandler from '../../events/event_handler';
import ImportedActivityFormEvents from './activity_form_events';

export const ActivityFormEvents = ImportedActivityFormEvents;
export const ActivityFormEventHandler = new EventHandler(Object.values(ActivityFormEvents));

export default ActivityFormEventHandler;
